import { useShiftModalDataContext } from 'modals/ShiftModal/ShiftModalProvider.data.context';
import { buildTotalEstimatedPayoutRange } from '../../SendToAgenciesSummaryView.constants';
import { ShiftPay } from '..';

function OpenPayComponent() {
  const { data } = useShiftModalDataContext();
  const order = data!.order;

  const allOpenEstimatedTotalPayout = buildTotalEstimatedPayoutRange(
    order.position!.marketplacePriceRange!,
    order.totalDuration!,
  );

  return (
    <ShiftPay
      estimatedHourlyPay={order.position.marketplacePriceRange?.rangeLabel ?? '$0'}
      estimatedTotalPay={allOpenEstimatedTotalPayout}
    />
  );
}

export function OpenPay() {
  return <OpenPayComponent />;
}
